import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const adminPaymentService = createApi({
    reducerPath: "adminPaymentService",
    baseQuery: baseQuery,
    endpoints: (builder) => ({
      createPayment: builder.mutation<any, any>({
        query: (body: any) => ({
          url: `/admin-payment/charge`,
          body,
          method: "POST",
          headers: {
            PageName: "Admin Payment",
          },
        }),
      }),
    })
});

export const {
    useCreatePaymentMutation,
  } = adminPaymentService;